import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Utils
import { mixPanelSchedulerNewPost } from '@/utils/mixpanel/schedulerEvents';
import useToggle from '@/utils/hooks/utils/useToggle';

import { POST_CONTENT, POST_SETTINGS } from '@/lib/scheduler/postFunnel/steps';
// Libs
import { tabsList } from '@/lib/scheduler/tabs';

import Button from '@/components/base/Button';
// Components
import Icon from '@/components/base/Icon';
const FunnelModal = dynamic(() => import('@/components/pages/scheduler/PostFunnel/FunnelModal'));

const PostStepAvailable = {
    2: POST_CONTENT,
    3: POST_SETTINGS
};

export const OldButtonFunnelModal = ({ setNeedReloadScheduledPosts }) => {
    const { t } = useTranslation('scheduler');
    const router = useRouter();
    const { post_id, library_media_id, post_step } = router.query;

    const {
        isOpen: isOpenPostFunnel,
        toggle: togglePostFunnel,
        params: paramsPostFunnel,
        setParams: setParamsPostFunnel
    } = useToggle();

    useEffect(() => {
        if (!isOpenPostFunnel) {
            if (post_id) {
                setParamsPostFunnel({
                    postId: post_id,
                    step: PostStepAvailable?.[post_step ?? 3] ?? POST_SETTINGS
                });
                togglePostFunnel();
            } else if (library_media_id) {
                setParamsPostFunnel({
                    libraryMediaId: library_media_id
                });
                togglePostFunnel();
            }
        }
    }, [post_id, library_media_id]);

    return (
        <>
            <Button
                id="calendar"
                className="create-new-add px-8"
                onClick={() => {
                    let event = 'main_cta_calendar';
                    if (router.pathname.includes(tabsList[1]?.url)) {
                        event = 'main_cta_feed';
                    }
                    mixPanelSchedulerNewPost(event);
                    togglePostFunnel();
                }}>
                <span>
                    <Icon icon="plus" className="mr-3 align-bottom" />
                    {t('schedule_new_post')}
                </span>
            </Button>
            <FunnelModal
                isOpen={isOpenPostFunnel}
                params={paramsPostFunnel}
                toggle={() => {
                    setParamsPostFunnel(null);
                    togglePostFunnel();
                }}
                callbackSuccessSubmitPost={() => setNeedReloadScheduledPosts(true)}
            />
        </>
    );
};
